export default __webpack_public_path__ + "static/media/Cómo_eliminar_Cookies_e_Historial.0081ec7d.pdf";